import angular from 'angular';
import { DashboardUnclaimedWorkOrdersContainerComponent } from './unclaimed-work-orders-container.component';
import { DashboardUnclaimedWorkOrdersComponent } from './unclaimed-work-orders.component';
import { dashboardUnclaimedWorkOrdersItemTemplate, dashboardUnclaimedWorkOrdersListItemTemplate } from './dashboard-unclaimed-work-orders-templates.block';

export const WorkOrderDashboardModule = angular
    .module("apex.mainApp.workOrder.dashboard", [])
    .component("apexDashboardUnclaimedWorkOrdersContainer", DashboardUnclaimedWorkOrdersContainerComponent)
    .component("apexDashboardUnclaimedWorkOrders", DashboardUnclaimedWorkOrdersComponent)
    .run(dashboardUnclaimedWorkOrdersItemTemplate)
    .run(dashboardUnclaimedWorkOrdersListItemTemplate)
    .name;
